import { render, staticRenderFns } from "./AdmisionReporteInstitucion.vue?vue&type=template&id=c409243e&scoped=true"
import script from "./AdmisionReporteInstitucion.vue?vue&type=script&lang=js"
export * from "./AdmisionReporteInstitucion.vue?vue&type=script&lang=js"
import style0 from "./AdmisionReporteInstitucion.vue?vue&type=style&index=0&id=c409243e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c409243e",
  null
  
)

export default component.exports